import Email_templates from './components/Email_Templates';

export default Email_templates;
